export const documentSourceOptions = [
  { label: 'MAX System', value: 'max-system' },
  { label: 'Customer', value: 'customer' },
  { label: '3rd Party System', value: '3rd-party-system' },
  { label: 'DS or MAX System', value: 'ds-or-max-system' },
  { label: 'DS 3rd Party System', value: 'ds-3rd-party-system' },
]

export const documentCategoryOptions = [
  { label: 'Disclosure', value: 'disclosure' },
  { label: 'Underwriting', value: 'underwriting' },
  { label: 'Contract Set', value: 'contract-set' },
  { label: 'Email', value: 'email' },
  { label: 'Surveillance', value: 'surveillance' },
  { label: 'Servicing', value: 'servicing' },
]

export const documentTagOptions = [
  'Deal Files',
  'Deal Files/AVM Docs',
  'Deal Files/Appraisal Docs',
  'Deal Files/CX Docs',
  'Deal Files/Co-Owner Docs',
  'Deal Files/Client Signed Docs',
  'Deal Files/Contract Docs',
  'Deal Files/Deferment-Forbearance Docs',
  'Deal Files/DTI Docs',
  'Deal Files/Digital Certificates',
  'Deal Files/Expired / Not Needed',
  'Deal Files/HEO Docs',
  'Deal Files/HOA Docs',
  'Deal Files/Inspection Docs',
  'Deal Files/NOO Docs',
  'Deal Files/Payoff Docs',
  'Deal Files/POA Docs',
  'Deal Files/Post-Closing Docs',
  'Deal Files/Rental Docs',
  'Deal Files/Solar Docs',
  'Deal Files/Title Docs',
  'Deal Files/Trust Docs',
  'Deal Files/z-Raw Data',
  'Servicing',
  'Servicing/Statements',
  'Servicing/Buyout Docs',
  'Servicing/Home Sale Docs',
  'Servicing/Subordination Docs',
  'Servicing/Unlock Refi Docs',
  'Servicing/Home Improvement Docs',
  'Servicing/Generated Docs',
  'Servicing/Other Docs',
  'Post Origination/Credit',
  'Post Origination/Lien Alerts',
  'Post Origination/Insurance',
  'Post Origination/Final Disposition',
  'Post Origination/Servicing',
]

export const DOCUMENT_TYPE = {
  APPLICATION: 'application',
  HOMEOWNER_DOCS: 'homeowner-docs',
  CREDIT: 'credit',
  AVM: 'avm',
  SUPPLEMENTAL: 'supplemental',
  LEGAL: 'legal',
  APPRAISAL: 'appraisal',
  TITLE: 'title',
  INSPECTION: 'inspection',
  CLOSING: 'closing',
  HOA: 'hoa',
  MESSAGE_REPLY: 'message-reply',
  EMAIL: 'email',
  CREDIT_REPORTS: 'credit-reports',
  LIEN_ALERTS: 'lien-alerts',
  INSURANCE: 'insurance',
  FINAL_DISPOSITION: 'final-disposition',
  SERVICING: 'servicing',
}

export const DOCUMENT_CATEGORY = {
  DISCLOSURE: 'disclosure',
  UNDERWRITING: 'underwriting',
  CONTRACT_SET: 'contract-set',
  EMAIL: 'email',
  SURVEILLANCE: 'surveillance',
  SERVICING: 'servicing',
}

export const DOCUMENT_TAG = {
  DEAL_FILES: 'Deal Files',
  DEAL_FILES_AVM_DOCS: 'Deal Files/AVM Docs',
  DEAL_FILES_APPRAISAL_DOCS: 'Deal Files/Appraisal Docs',
  DEAL_FILES_CX_DOCS: 'Deal Files/CX Docs',
  DEAL_FILES_CLIENT_SIGNED_DOCS: 'Deal Files/Client Signed Docs',
  DEAL_FILES_CONTRACT_DOCS: 'Deal Files/Contract Docs',
  DEAL_FILES_DEFERMENT_FORBEARANCE_DOCS: 'Deal Files/Deferment-Forbearance Docs',
  DEAL_FILES_DTI_DOCS: 'Deal Files/DTI Docs',
  DEAL_FILES_EXPIRED_NOT_NEEDED: 'Deal Files/Expired / Not Needed',
  DEAL_FILES_HEO_DOCS: 'Deal Files/HEO Docs',
  DEAL_FILES_HOA_DOCS: 'Deal Files/HOA Docs',
  DEAL_FILES_INSPECTION_DOCS: 'Deal Files/Inspection Docs',
  DEAL_FILES_NOO_DOCS: 'Deal Files/NOO Docs',
  DEAL_FILES_PAYOFF_DOCS: 'Deal Files/Payoff Docs',
  DEAL_FILES_POA_DOCS: 'Deal Files/POA Docs',
  DEAL_FILES_POST_CLOSING_DOCS: 'Deal Files/Post-Closing Docs',
  DEAL_FILES_RENTAL_DOCS: 'Deal Files/Rental Docs',
  DEAL_FILES_SOLAR_DOCS: 'Deal Files/Solar Docs',
  DEAL_FILES_TITLE_DOCS: 'Deal Files/Title Docs',
  DEAL_FILES_RAW_DATA: 'Deal Files/z-Raw Data',
  SERVICING: 'Servicing',
  SERVICING_STATEMENTS: 'Servicing/Statements',
  SERVICING_BUYOUT_DOCS: 'Servicing/Buyout Docs',
  SERVICING_HOME_SALE_DOCS: 'Servicing/Home Sale Docs',
  SERVICING_SUBORDINATION_DOCS: 'Servicing/Subordination Docs',
  SERVICING_UNLOCK_REFI_DOCS: 'Servicing/Unlock Refi Docs',
  SERVICING_HOME_IMPROVEMENT_DOCS: 'Servicing/Home Improvement Docs',
  SERVICING_GENERATED_DOCS: 'Servicing/Generated Docs',
  SERVICING_OTHER_DOCS: 'Servicing/Other Docs',
  DEAL_FILES_TRUST_DOCS: 'Deal Files/Trust Docs',
}

export const DOCUMENT_SOURCE = {
  MAX_SYSTEM: 'max-system',
  CUSTOMER: 'customer',
  THIRD_PARTY_SYSTEM: '3rd-party-system',
  DS_OR_MAX_SYSTEM: 'ds-or-max-system',
  DS_THIRD_PARTY_SYSTEM: 'ds-3rd-party',
}

export const DOCUMENT_OPTIONS = {
  INITIAL_APPLICATION_UNLOCK_AGREEMENT: 'initial-application-for-unlock-agreement',
  AVM_REPORT_XML: 'avm-report-xml',
  APPLICANT_IDENTIFICATION: 'applicant-id',
  CO_APPLICANT_IDENTIFICATION: 'co-applicant-identification',
  NON_APPLICANT_IDENTIFICATION: 'non-applicant-identification',
  MORTGAGE_STATEMENT_XML: 'mortgage-statement-xml',
  MORTGAGE_STATEMENT_FIRST: 'mortgage-statement-first',
  MORTGAGE_STATEMENT_SECOND: 'mortgage-statement-second',
  HOMEOWNERS_INSURANCE: 'homeowners-insurance',
  HOMEOWNERS_ASSOCIATION_BILL: 'homeowners-association-bill',
  MOST_RECENT_PAYSTUB: 'paystubs--most-recent',
  NEXT_MOST_RECENT_PAYSTUB: 'paystubs--next-recent',
  LAST_YEAR_TAX_RETURNS: 'self-income--tax-returns-last-year',
  YEAR_BEFORE_LAST_TAX_RETURNS: 'self-income--tax-returns-year-before',
  LAST_YEAR_FINAL_PAYCHECK_STUBS: 'paycheck-stubs--last-year',
  YEAR_BEFORE_LAST_FINAL_PAYCHECK_STUBS: 'paycheck-stubs--year-before-last',
  RETIREE_BENEFIT_LETTER: 'rap-income--retiree',
  SOLAR_PANEL_AGREEMENT: 'property--solar-panel-agreement',
  RENTAL_INCOME_PROOF: 'rental-income-proof',
  TRUST_DOCUMENTS: 'trust-documents',
  CREDIT_REPORT: 'credit-report',
  CREDIT_REPORT_XML: 'credit-report-xml',
  CREDIT_REPORT_XML_FROZEN: 'credit-report-xml-frozen',
  VERIFICATION_MORTGAGE_CREDIT_SUPPLEMENT: 'verification-of-mortgage-credit-supplement',
  CORELOGIC_CONSUMER_AVM: 'corelogic-consumer-avm',
  CORELOGIC_RISK_AVM: 'corelogic-risk-avm',
  BKFS_CA_VALUE_AVM: 'bkfs-ca-value-avm',
  CLEAR_CAPITAL_AVM: 'clear-capital-avm',
  ACCURATE_GROUP_AVM: 'accurate-group-avm',
  HOUSECANARY_AVM: 'housecanary-avm',
  HOUSECANARY_HPA_FORECAST: 'housecanary-hpa-forecast',
  CAPE_ANALYTICS_PROPERTY_CONDITION: 'cape-analytics-property-condition',
  INCOME_DOCUMENTATION: 'income-documentation',
  LETTER_OF_EXPLANATION: 'letter-of-explanation',
  OTHER: 'other',
  INVESTMENT_ESTIMATE: 'investment-estimate',
  UNLOCK_PROGRAM_GUIDE: 'unlock-program-guide',
  INVESTMENT_ESTIMATE_EXECUTED: 'investment-estimate-executed',
  APPRAISAL: 'appraisal',
  APPRAISAL_PDF: 'appraisal-pdf',
  APPRAISAL_XML: 'appraisal-xml',
  TITLE_REPORT_XML: 'title-report-xml',
  PRELIMINARY_TITLE_REPORT: 'preliminary-title-report',
  FINAL_TITLE_REPORT: 'final-title-report',
  HOME_INSPECTION_REPORT: 'home-inspection-report',
  TERMITE_INSPECTION_REPORT: 'termite-inspection-report',
  DEFERRED_MAINTENANCE_ITEMS: 'deferred-maintenance-items',
  CLOSING_STATEMENT: 'closing-statement',
  CET_CLOSING_STATEMENT: 'cet-closing-statement',
  SAMPLE_FORWARD_SALE_AND_EXCHANGE_AGREEMENT: 'sample-forward-sale-and-exchange-agreement',
  SAMPLE_PERFORMANCE_DEED_OF_TRUST: 'sample-performance-deed-of-trust',
  FINAL_APPLICATION_FOR_UNLOCK_AGREEMENT: 'final-application-for-unlock-agreement',
  CLOSING_STATEMENT_EXECUTED: 'closing-statement-executed',
  FINAL_APPLICATION_FOR_UNLOCK_AGREEMENT_EXECUTED:
    'final-application-for-unlock-agreement-executed',
  FORWARD_SALE_AND_EXCHANGE_AGREEMENT: 'forward-sale-and-exchange-agreement',
  PERFORMANCE_DEED_OF_TRUST: 'performance-deed-of-trust',
  TITLE_FINAL_SETTLEMENT_STATEMENT: 'title-final-settlement-statement',
  CLOSING_INSTRUCTIONS: 'closing-instructions',
  SEARCH_PACKAGE: 'search-package',
  TAX_CERTIFICATION: 'tax-certification',
  RECORDED_DOCS: 'recorded-docs',
  EXECUTED_CLOSING_DOCS: 'executed-closing-docs',
  CLOSING_PACKAGE: 'closing-package',
  FORWARD_SALE_AND_EXCHANGE_AGREEMENT_EXECUTED: 'forward-sale-and-exchange-agreement-executed',
  PERFORMANCE_DEED_OF_TRUST_EXECUTED: 'performance-deed-of-trust-executed',
  PERFORMANCE_DEED_OF_TRUST_RECORDED: 'performance-deed-of-trust-recorded',
  MASTER_HOA_INSURANCE: 'master-hoa-insurance',
  LITIGATION_EMAIL: 'litigation-email',
  HOA_CERTIFICATE: 'hoa-Certificate',
  CONDO_QUESTIONNAIRE: 'condo-questionnaire',
  SIGN_HERE: 'sign-here',
  PAYOFF: 'payoff',
  FORBEARANCE: 'forbearance',
  AAN_EMAIL: 'ann-email',
  DATA_TREE_REPORT: 'data-tree-report',
  LOE_MORTGAGE_INQUIRIES: 'Loe - Mortgage Inquiries',
  HOMEOWNERS_ASSN_DUES: 'Homeowners Assn Dues',
  DEBT_PAYOFF_EVIDENCE: 'Debt Payoff Evidence',
  MORTGAGE_PAYOFF_STATEMENT: 'Mortgage Payoff Statement',
  BANKRUPTCY_DISCHARGE_PAPERS: 'Bankruptcy Discharge Papers',
  VERIFICATION_OF_RENT: 'Verification Of Rent',
  WIDOWED_DEATH_CERT: 'Widowed - Death Cert',
  SEPARATED_SEPARATION_AGREEMENT: 'Separated - Separation Agreement',
  ALIMONY_CHILD_SUPPORT_LIABILITY: 'Alimony / Child Support Liability',
  W2_INCOME: 'W-2 Income',
  SELF_EMPLOYED_INCOME: 'Self-Employed Income',
  BONUS_COMMISSION_OT_INCOME: 'Bonus/Commission/Ot Income',
  VA_BENEFITS_INCOME: 'Va Benefits Income',
  SOCIAL_SECURITY: 'Social Security',
  PENSION: 'Pension',
  MILITARY_RELATED_INCOME: 'Military Related Income',
  FORBEARANCE_DOCUMENT: 'Forbearance Document',
  CLOSING_STATEMENT_NON_APPLICANT_ACKNOWLEDGEMENT:
    'closing-statement-non-applicant-acknowledgement',
}

/** These values are sourced from /backend/documents/constants/document.py */
export const documentKinds = [
  { value: 'government-id--drivers-license', label: "U.S. State-issued Driver's License" },
  { value: 'government-id--passport', label: 'U.S. Passport' },
  { value: 'government-id--green-card', label: 'Green Card' },
  { value: 'government-id--generic', label: 'Applicant ID' },
  { value: 'personal--marriage-certificate', label: 'Marriage Certificate' },
  { value: 'personal--divorce-decree', label: 'Divorce Decree' },
  { value: 'personal--power-of-attorney', label: 'Power of Attorney' },
  { value: 'personal--verification-of-ssn', label: 'Verification of SSN' },
  { value: 'identification', label: 'Applicant Identification' },
  { value: 'co-applicant-identification', label: 'Co-Applicant Identification' },
  { value: 'non-applicant-identification', label: 'Non-Applicant Identification' },
  { value: 'widowed-death-cert', label: 'Widowed - Death Cert' },
  { value: 'separation-agreement', label: 'Separated - Separation Agreement' },
  {
    value: 'property--additional-property-insurance',
    label: "Declaration pages: Add'l property insurance",
  },
  { value: 'income--p-and-l-statements', label: 'P&L Statements' },
  { value: 'title--foreclosure-documents', label: 'Foreclosure Documents' },
  { value: 'title--judgement-documents', label: 'Judgement Documents' },
  { value: 'credit--verification-of-mortgage', label: 'Verification of Mortgage (VOM)' },
  { value: 'property--flood-insurance-policy', label: 'Flood Insurance Policy' },
  { value: 'property--home-inspection-notice', label: 'Home Inspection Notice' },
  { value: 'property--mortgage-statement', label: 'Mortgage Statement' },
  { value: 'mortgage-statement-first', label: 'Mortgage Statement - First' },
  { value: 'mortgage-statement-second', label: 'Mortgage Statement - Second' },
  { value: 'mortgage-payoff-statement', label: 'Mortgage Payoff Statement' },
  { value: 'property--property-tax', label: 'Property Tax' },
  { value: 'property--title-lien-release', label: 'Title - Lien Release' },
  { value: 'property--rental-agreement', label: 'Rental or Lease Agreement' },
  { value: 'verification-of-rent', label: 'Verification of Rent' },
  { value: 'property--home-owners-insurance-policy', label: 'Home Owners Insurance Policy' },
  { value: 'property--home-owners-insurance', label: 'Home Owners Insurance' },
  { value: 'trust-documents', label: 'Trust Documents' },
  { value: 'loe-mortgage-finance-inquires', label: 'LOE - Mortgage Inquiries' },
  { value: 'homeowners-assn-dues', label: 'Homeowners Assn Dues' },
  { value: 'debt-payoff-evidence', label: 'Debt Payoff Evidence' },
  { value: 'forbearance-document', label: 'Forbearance Document' },
  { value: 'property--trust-agreement', label: 'Trust Agreement' },
  { value: 'property--homeowners-association-bill', label: "Homeowner's Association Bill" },
  { value: 'property--solar-panel-agreement', label: 'Solar Panel Agreement' },
  { value: 'property--appraisal-order', label: 'Appraisal Order' },
  { value: 'assets--asset-statement', label: 'Asset Statement' },
  { value: 'assets--bank-deposit-slip', label: 'Bank Deposit Slip' },
  { value: 'assets--account-statement', label: 'Account Statement' },
  { value: 'income--4506-t', label: '4506-T' },
  { value: 'income--balance-sheet', label: 'Balance Sheet' },
  { value: 'income--alimony-income', label: 'Alimony Income' },
  { value: 'income--w2-income', label: 'W-2 Income' },
  { value: 'income--self-income', label: 'Self Employed Income' },
  { value: 'income--bonus-income', label: 'Bonus Income' },
  { value: 'income--retirement-income', label: 'Retirement Income' },
  { value: 'income--social-income', label: 'Social Security Income' },
  { value: 'income--va-income', label: 'VA Benefits Income' },
  { value: 'income--other-income', label: 'Other Income' },
  { value: 'rental-income-proof', label: 'Rental Income Proof' },
  { value: 'w-2--recent', label: 'Most Recent W-2' },
  { value: 'military-related-income', label: 'Military Related Income' },
  { value: 'paystubs--most-recent', label: 'Most Recent Paystub' },
  { value: 'paystubs--next-recent', label: 'Next Most Recent Paystub' },
  { value: 'paycheck-stubs--latest', label: 'YTD Paycheck Stubs' },
  { value: 'paycheck-stubs--last-year', label: 'Last Year Final Paycheck Stubs' },
  { value: 'paycheck-stubs--year-before-last', label: 'Year Before Last Final Paycheck Stubs' },
  { value: 'rap-income--retiree', label: 'Retiree Benefit Letter' },
  { value: 'self-income--tax-returns-last-year', label: 'Last Year Tax Returns' },
  { value: 'self-income--tax-returns-year-before', label: 'Year Before Last Tax Returns' },
  { value: 'liabilities--bankruptcy-discharge-notice', label: 'Bankruptcy Discharge Notice' },
  { value: 'bankruptcy-discharge-papers', label: 'Bankruptcy Discharge Papers' },
  { value: 'pension', label: 'Pension' },
  { value: 'liabilities--credit-report', label: 'Credit Report' },
  { value: 'other--generic', label: 'Other' },
  { value: 'acknowledge--ie', label: 'Acknowledge IE' },
  { value: 'acknowledge--product-guide', label: 'Acknowledge Product Guide' },
  { value: 'acknowledge--ics', label: 'Acknowledge ICS' },
  { value: 'acknowledge--document', label: 'Acknowledge Document' },
  { value: 'sharepoint-transferred', label: 'Transferred from Sharepoint' },
  { value: 'servicing--marriage--marriage-certificate', label: 'Marriage Certificate' },
  {
    value: 'servicing--marriage--mortgage-statement-title-change',
    label: 'Recent Mortgage Statement',
  },
  { value: 'servicing--improvement-adjustment', label: 'Servicing Improvement Adjustment' },
  {
    value: 'servicing--improvement-adjustment--texts',
    label: 'Servicing Improvement Adjustment texts',
  },
  { value: 'servicing--improvement-adjustment--receipts', label: 'Improvement Receipts' },
  {
    value: 'servicing--improvement-adjustment--before-maintenance',
    label: 'Before Improvement Photos',
  },
  {
    value: 'servicing--improvement-adjustment--after-maintenance',
    label: 'After Improvement Photos',
  },
  { value: 'servicing--proof-of-name-change', label: 'Proof of Name Change' },
  { value: 'servicing--proof-of-transfer-to-trust', label: 'Proof of Trust' },
  { value: 'servicing--document-uploads', label: 'Purchase Agreement' },
  { value: 'servicing--payoff-request', label: 'Servicing Payoff Request' },
  {
    value: 'servicing--subordination-request',
    label: 'Mortgage Refinance Subordination Documents',
  },
  { value: 'servicing--subordination-request--loan-estimate', label: 'Servicing Loan Estimate' },
  {
    value: 'servicing--subordination-request--receipt-appraisal',
    label: 'Servicing Receipt Appraisal',
  },
  { value: 'servicing--subordination-request--title-report', label: 'Servicing Title Report' },
  {
    value: 'servicing--subordination-request--mortgage-statements',
    label: 'Servicing Mortgage Statements',
  },
  { value: 'servicing--subordination-request--prepaid-fedex', label: 'Servicing Prepaid Fedex' },
  { value: 'servicing--mortgage-information', label: 'Servicing Mortgage Information' },
  { value: 'servicing--lien-release-clear-edge', label: 'Servicing Lien Release Clear Edge' },
  { value: 'aan-email', label: 'Adverse Action Notice Email' },
  { value: 'esignature--signed-document', label: 'E-Signature Signed Document' },
  { value: 'esignature--certificate', label: 'E-Signature Certificate' },
  { value: 'esignature--preview', label: 'E-Signature Preview' },
  { value: 'qcs--report', label: 'Quarterly Customer Statement Report' },
  { value: 'consent--credit', label: 'Credit Consent' },
  { value: 'consent--telephone', label: 'Telephone Consent' },
  { value: 'consent--electronic-disclosures', label: 'Electronic Disclosures Consent' },
  { value: 'disclosure--non-applicant-disclosure', label: 'Non-Applicant Disclosure' },
  { value: 'post-origination--credit-reports', label: 'Post Origination Credit Reports' },
  { value: 'post-origination--lien-alerts', label: 'Post Origination Lien Alerts' },
  { value: 'post-origination--insurance', label: 'Post Origination Insurance' },
  { value: 'post-origination--final-disposition', label: 'Post Origination Final Disposition' },
  { value: 'post-origination--servicing', label: 'Post Origination Servicing' },
]
